import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QSetReviewHistoryProvider } from '@exam-management/qset-review-history';
import { useParams } from '@exam-management/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QSetReviewHistoryLayout() {
  const { qSetId } = useParams('/exam-courses/:courseId/qsets/:qSetId/review-history');

  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.QSET.VIEW]}>
      <QSetReviewHistoryProvider qSetId={qSetId}>
        <Outlet />
      </QSetReviewHistoryProvider>
    </PermissionGuard>
  );
}
